import React from "react";
import "./PrivacyDeletation.css";
import sr1 from "./sr1.png";
import sr2 from "./sr2.png";
import sr3 from "./sr3.png";

function PrivacyDeletation() {
  return (
    <div className="privacy-container">
      <h3 className="privacy-title">Account Deletion Guide for JR Care Mobile App</h3>
      <span className="privacy-intro">
        We understand that users may wish to delete their accounts for various
        reasons. If you decide to proceed with account deletion, please follow
        the steps below:{" "}
      </span>
      <br />
      <h3 className="steps-title">Steps to Delete Your Account</h3>
      
      <div className="step-item">
        <p className="step-number">1. Login to JR Care Mobile App</p>
        <ul className="step-list">
          <li>Open the JR Care mobile app on your device.</li>
          <li>Navigate to the Profile page. (Refer to the screenshot below)</li>
        </ul>
        <div className="image-wrapper">
          <img src={sr1} alt="Profile page screenshot" className="step-image" />
        </div>
      </div>
      
      <div className="step-item">
        <p className="step-number">2. Initiate Account Deletion</p>
        <ul className="step-list">
          <li>Scroll to the bottom of the Profile page.</li>
          <li>
            Tap on the 'Delete Account' link. (Refer to the screenshot below){" "}
          </li>
        </ul>
        <div className="image-wrapper">
          <img src={sr2} alt="Delete account link screenshot" className="step-image" />
        </div>
      </div>
      
      <div className="step-item">
        <p className="step-number">3. Confirm Deletion</p>
        <ul className="step-list">
          <li>Enter your password in the provided field.</li>
          <li>
            Tap the 'Confirm' button to proceed (Refer to the screenshot below).{" "}
          </li>
        </ul>
        <div className="image-wrapper">
          <img src={sr3} alt="Confirm deletion screenshot" className="step-image" />
        </div>
      </div>
      
      <div className="important-info">
        <h4 className="info-title">Important Information</h4>
        <ul className="info-list">
          <li>
            Your account and all associated data will be permanently deleted.{" "}
          </li>
          <li>Once deleted, your account cannot be recovered.</li>
          <li>
            If you wish to use the JR Care app again, you will need to create a
            new account.{" "}
          </li>
        </ul>
      </div>
      
      <div className="support-info">
        <span>
          If you need any assistance, feel free to contact our support team at
          developer@jrcareltd.com. Thank you for using JR Care!{" "}
        </span>
      </div>
    </div>
  );
}

export default PrivacyDeletation;